<template>
    <div class="overall-accounts-overview">

        <section v-if="suppliers">
            <h2>Suppliers We Owe The Most To <small class="price-overview" v-if="overview_data">£{{ overview_data.pi.total_awaiting_payment.total | money }}<br /><span><strong>Overdue: </strong>£{{ overview_data.pi.overdue.total | money }}</span></small></h2>
            <hr />
            <table class="dashed">
                <tbody>
                <tr v-for="supplier in suppliers">
                    <td><strong>{{ supplier.name }}: </strong></td>
                    <td style="text-align:right;">£{{ supplier.amount }}</td>
                </tr>
                </tbody>
            </table>
        </section>

        <section v-if="customers">
            <h2>Customers Who Owe Us The Most <small class="price-overview" v-if="overview_data">£{{ overview_data.si.total_awaiting_payment.total | money }}<br /><span><strong>Overdue: </strong>£{{ overview_data.si.overdue.total | money }}</span></small></h2>
            <hr />
            <table class="dashed">
                <tbody>
                <tr v-for="customer in customers" >
                    <td><strong>{{ customer.name }}: </strong></td>
                    <td style="text-align:right;">£{{ customer.amount }}</td>
                </tr>
                </tbody>
            </table>
        </section>
        <section>

            <h1>Purchase Orders</h1>

            <div v-if="!overview_data" class="loading-spinner">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>

            <table v-else>
                <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Amount</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                <tr><td>Awaiting Approval</td><td>{{ overview_data.po.total_awaiting_approval.count }}</td><td>£{{ overview_data.po.total_awaiting_approval.total | money }}</td></tr>
                <tr><td>Pending</td><td>{{ overview_data.po.total_pending.count }}</td><td>£{{ overview_data.po.total_pending.total | money }}</td></tr>
                <tr><td>Disputed</td><td>{{ overview_data.po.total_disputed.count }}</td><td>£{{ overview_data.po.total_disputed.total | money }}</td></tr>
                </tbody>
            </table>

        </section>

        <section>
            <h1>AFP's</h1>

            <div v-if="!overview_data" class="loading-spinner">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>

            <table v-else>
                <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Amount</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                <tr><td>Latest Measure</td><td>{{ overview_data.afp.total_latest_measure.count }}</td><td>£{{ overview_data.afp.total_latest_measure.total | money }}</td></tr>
                <tr><td>Latest AFP Value</td><td>{{ overview_data.afp.total_latest_afp_values.count }}</td><td>£{{ overview_data.afp.total_latest_afp_values.total | money }}</td></tr>
                <tr><td>Certificate Value</td><td>{{ overview_data.afp.total_cert_values.count }}</td><td>£{{ overview_data.afp.total_cert_values.total | money }}</td></tr>
                <tr><td>Balance</td><td>&nbsp;</td><td>£{{ overview_data.afp.total_balance | money }}</td></tr>
                <tr><td>WIP</td><td>&nbsp;</td><td>£{{ overview_data.afp.total_wip | money }}</td></tr>
                </tbody>
            </table>

        </section>
        <section>
            <h1>Purchase Invoices Awaiting Approval</h1>

            <table v-if="overview_data">
                <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Amount</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                    <tr><td>Awaiting Approval</td><td>{{ overview_data.pi.total_awaiting_approval.count }}</td><td>£{{ overview_data.pi.total_awaiting_approval.total | money }}</td></tr>
                    <tr><td>Disputed</td><td>{{ overview_data.pi.total_disputed.count }}</td><td>£{{ overview_data.pi.total_disputed.total | money }}</td></tr>
                </tbody>
            </table>
            <div v-else class="loading-spinner loading-spinner-compact">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>


            <table class="responsive-table" v-if="pi">
                <thead>
                <tr>
                    <th scope="col"># Of Invoices</th>
                    <th scope="col">To Be Approved By</th>
                    <th scope="col">Amount (inc VAT)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="group in pi">
                    <td scope="row" data-label="# Of Invoices"><a :href="piApprovalUrl">{{ group.number }}</a></td>
                    <td data-label="To Be Approved"><a :href="piApprovalUrl">{{ group.contact }}</a></td>
                    <td data-label="Amount"><a :href="piApprovalUrl">£{{ group.amount }}</a></td>
                </tr>
                </tbody>
            </table>
        </section>

        <section>
            <h1>Sales Invoices Awaiting Approval</h1>

            <table v-if="overview_data">
                <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Amount</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                <tr><td>Awaiting Approval</td><td>{{ overview_data.si.total_awaiting_approval.count }}</td><td>£{{ overview_data.si.total_awaiting_approval.total | money }}</td></tr>
                <tr><td>Disputed</td><td>{{ overview_data.si.total_disputed.count }}</td><td>£{{ overview_data.si.total_disputed.total | money }}</td></tr>
                </tbody>
            </table>
            <div v-else class="loading-spinner loading-spinner-compact">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>

            <table class="responsive-table" v-if="si">
                <thead>
                <tr>
                    <th scope="col"># Of Invoices</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Amount (inc VAT)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="group in si">
                    <td scope="row" data-label="# Of Invoices">{{ group.number }}</td>
                    <td data-label="To Be Approved">{{ group.contact }}</td>
                    <td data-label="Amount">£{{ group.amount }}</td>
                </tr>
                </tbody>
            </table>
        </section>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: 'accounts-overview',
                overview_data: null,
                pi: null,
                si: null,
                customers: null,
                suppliers: null,
            }
        },
        props:['piApprovalUrl'],
        filters: {
            money: function (val) {
                var parsed = parseFloat(val).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                return parsed;
            }
        },
        watch: {
        },
        computed: {
            fully_loaded() {
                return !_.isNull(this.overview_data) && !_.isNull(this.pi) && !_.isNull(this.si) && !_.isNull(this.customers) && !_.isNull(this.suppliers);
            }
        },
        methods: {
            getItems() {
                var that = this;
                axios.get(appUrls.accounts.overview.overview).then(response => { that.overview_data = response.data; });
                axios.get(appUrls.accounts.overview.customers).then(response => { that.customers = response.data; });
                axios.get(appUrls.accounts.overview.suppliers).then(response => { that.suppliers = response.data; });
                axios.get(appUrls.accounts.overview.pi).then(response => { that.pi = response.data; });
                axios.get(appUrls.accounts.overview.si).then(response => { that.si = response.data; });
            }
        },
        mounted() {
            var that = this;
            this.getItems();
        }
    }
</script>

<style lang="scss" scoped>
    /*SASS Goes Here*/
    @import '../../sass/setup';
    .price-overview{
        float:right;
        color:$red;
        font-size:20px;
        text-align:right;
        span{
            font-size:15px;
            strong{
                color:#333;
                font-weight:400;
            }
        }
    }
    section > h2{
        @include clearfix();
    }
    table.dashed tr{
        border-bottom: 1px dashed #ddd;
    }

    table {
        border-collapse: collapse;
        margin: 1.5em 0;
        table-layout: fixed;
        text-align: left;
        width: 100%;
    }

    thead {
        line-height: 1.2;
        vertical-align: bottom;
    }

    tbody {
        vertical-align: top;
    }

    tr {
        border-bottom: 1px solid #ddd;
    }

    th {
        font-weight: 600;
    }

    th,
    td {
        padding: 0.75em 0.75em 0.75em 0;
    }
</style>